import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const names = ['Mateo', 'Valentina', 'Santiago', 'Sofía', 'Matías', 'Camila', 'Lucas', 'Martina', 'Joaquín', 'Lucía', 'Nicolás', 'María', 'Tomás', 'Paula', 'Facundo', 'Florencia', 'Agustín', 'Micaela', 'Lautaro', 'Julieta'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'Tucumán', 'La Plata', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Santiago del Estero', 'Corrientes', 'Posadas', 'Montevideo', 'Santiago', 'Bogotá', 'Lima', 'CDMX'];
export const SocialProofPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      setCurrentPurchase({
        name: randomName,
        city: randomCity
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    const initialTimer = setTimeout(() => {
      showPopup();
      const interval = setInterval(() => {
        showPopup();
      }, Math.floor(Math.random() * 5000) + 15000);
      return () => clearInterval(interval);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  return <AnimatePresence data-id="element-294">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 30,
      x: -10
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-3 left-3 sm:bottom-6 sm:left-6 z-50 max-w-[220px] sm:max-w-sm bg-white border border-neutral-200 rounded-lg sm:rounded-xl shadow-lg p-2 sm:p-4 flex items-center gap-2 sm:gap-4" data-id="element-295">
          <div className="bg-brand-50 rounded-full p-1 sm:p-2 flex-shrink-0" data-id="element-296">
            <CheckCircle2 className="w-3 h-3 sm:w-5 sm:h-5 text-brand-600" data-id="element-297" />
          </div>
          <div data-id="element-298">
            <p className="text-[10px] sm:text-sm text-neutral-700 leading-tight" data-id="element-299">
              <strong className="text-neutral-900" data-id="element-300">
                {currentPurchase.name}
              </strong>{' '}
              de {currentPurchase.city} compró
            </p>
            <p className="text-[9px] sm:text-xs font-bold text-brand-600 mt-0.5" data-id="element-301">
              CAJA DE COBRO
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};